/**
 * 获取货主数据接口
 */
import axios from "axios";

const debug = false;

const baseUrl = debug ? "http://127.0.0.1:8989" : "https://xda.slpzb.com";

export default {
  // 获取言臻活动货主销售数据接口
  getYjShipperData: async (payload) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/shipper_data/yz_shipper_data/`,
        { params: payload }
      );
      return response.data;
    } catch (error) {
      console.error("获取货主数据失败:", error);
      throw error;
    }
  },
  // 获取言臻活动分组，货主销售数据接口
  getYjShipperGroupData: async (payload) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/shipper_data/yz_shipper_group_data/`,
        { params: payload }
      );
      return response.data;
    } catch (error) {
      console.error("获取货主数据失败:", error);
      throw error;
    }
  },
};
